import { useEffect, useState } from 'react'

import CommonColorPickerStyles from 'common/ColorPicker/ColorPicker.module.scss'
import SpecialColorPickerStypes from '../ColorPicker.module.scss'

import { Drawer } from 'components/Drawer'
import { observer } from 'mobx-react-lite'
import { DrawerProps } from 'components/Drawer/Root'
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props extends DrawerProps {
  color: string | null
  onChange: (color: string) => void
  previewColors?: string[]
  setPreviewColors?: (colors: string[]) => void
}

export const EditDrawer = observer(({ ...props }: Props) => {
  const { color, onChange, previewColors, setPreviewColors } = props
  const [localColor, setLocalColor] = useState(color)

  useEffect(() => {
    if (localColor) {
      onChange(localColor)

      // Also update preview state colors to reflect the change
      if (previewColors && setPreviewColors && color && localColor !== color) {
        const updatedColors = previewColors.map((c) => (c === color ? localColor : c))
        setPreviewColors(updatedColors)
      }
    }
  }, [localColor, onChange, previewColors, setPreviewColors, color])

  return (
    <Drawer.Root {...props} handleOnly={true}>
      <Drawer.Portal>
        <Drawer.Overlay />
        <Drawer.Content>
          <Drawer.Handle />
          <Drawer.InnerContent>
            <Drawer.Top>
              <Drawer.Close position="left" label="" />
              <Drawer.Title asChild>
                <Heading level={5}>Edit Color</Heading>
              </Drawer.Title>
              <Drawer.Close position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <div className={CommonColorPickerStyles.picker}>
                <HexAlphaColorPicker color={color || undefined} onChange={(newColor) => setLocalColor(newColor)} />
                <HexColorInput
                  color={localColor || undefined}
                  onChange={(newColor) => setLocalColor(newColor)}
                  onBlur={() => setLocalColor(localColor)}
                  className={SpecialColorPickerStypes.input}
                />
              </div>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
